module.exports = __webpack_public_path__ + "img/yas.c837d2fd.png";